import { Eye } from "lucide-react";
import React from "react";
import { cn } from "@/lib/utils";

interface BlogViewsProps {
  views: number;
  className?: string;
}

export default function BlogViews({ views, className }: BlogViewsProps) {
  return (
    <div className={cn("inline-flex items-center gap-1.5 text-sm text-stone-500 dark:text-stone-400 font-Cabin", className)}>
      <Eye className="h-3.5 w-3.5" />
      <span>{views.toLocaleString()}</span>
    </div>
  );
}
